import store from '@/store/index.js';
import windowStorageClearService from '@/services/window-storage-clear-service';

export default {

    refreshActingUserInfo() {
        store.dispatch('actingUser/refreshActingUserDetails')
    },
    setActingUser(userId, deputyTypeId) {

        windowStorageClearService.clearSessionStorage();
        windowStorageClearService.clearLocalStorage();
        windowStorageClearService.clearAllVuexStores();
        store.commit('actingUser/setUserToActFor', userId);
        store.commit('actingUser/setDeputyTypeId', deputyTypeId);

        window.location.replace('/');
    },
    removeActingUser() {
        windowStorageClearService.clearSessionStorage();
        windowStorageClearService.clearLocalStorage();
        windowStorageClearService.clearAllVuexStores();

        store.dispatch('routingHistory/setIntentionalUnusualForwarding', true);

        window.location.replace('/');
    }
}
